import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";

export default function Sigma() {
  const navigate = useNavigate();
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFaq = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  const storedCountry = localStorage.getItem("userCountry");
  const isIndia = storedCountry === "IN";
  const currencySymbol = isIndia ? "₹" : "$";
  const rate = isIndia ? 83 : 1;
  const getDisplayPrice = (usdAmount) => {
    const calculated = usdAmount * rate;
    return new Intl.NumberFormat(isIndia ? "en-IN" : "en-US").format(
      calculated,
    );
  };
  // Sigma plan data
  const sigmaPlanData = {
    planid: "sigma",
    name: "Sigma",
    price: 9999,
    duration: "90 days",
    currency: "INR",
    description: "Sigma Quadrant – 90 days entrepreneurship program",
    features: [
      "Business Development and MVP Creation",
      "Comprehensive 3-month Entrepreneurship Program",
      "Mentorship and Strategic Guidance",
      "Product Development Support",
    ],
  };

  const faqItems = [
    {
      title: "Month 1 - Assessing Product Market Fit",
      content: [
        "Establishing metrics for customer acquisition, retention, and revenue growth",
        "Operational efficiency and scaling processes",
        "Financial modelling for growth",
        "Constant Customer feedback and constant improvement on the products and services",
        "Developing strong sales funnels and customer journey maps",
        "Developing action plans for product improvements and market expansion",
        "Setting timelines and accountability structures",
      ],
    },
    {
      title: "Month 2 - Scaling Strategies",
      content: [
        "Researching other markets",
        "Identifying scaling opportunities",
        "Key performance indicators (KPIs) for growth",
        "Case studies on successful scaling strategies",
        "Peer accountability sessions to track progress",
        "Identify other regions to expand",
        "Adapting products for other regions' audiences",
      ],
    },
    {
      title: "Month 3 - Fundraising and Growth Execution",
      content: [
        "Understanding funding options (equity, debt, grants)",
        "Crafting a pitch deck and financial projections",
        "Networking event with potential investors and mentors",
        "Mock pitch sessions with feedback from industry experts",
        "Finalizing pitch decks based on feedback",
        "Final pitch preparation: Tailoring presentations for different audiences",
        "One-on-one coaching sessions with mentors",
        "Investor meeting simulations",
        "Understanding term sheets, deal structures and investment agreements",
        "Negotiation strategies with potential investors",
        "Building relationships with investors and managing follow-ups",
        "Final pitch presentations to a panel of investors",
        "Reflecting on the journey: Lessons learned and next steps",
        "Creating a post-program growth plan with mentor support",
      ],
    },
  ];

  // Function to handle plan selection and navigate to signup
  const handlePlanSelect = () => {
    // Navigate to signup with plan data
    navigate("/Signup", { state: { selectedPlan: sigmaPlanData } });
  };

  return (
    <div>
      <section className="faq mega-section page-hero mt-5" id="faq">
        <div className="container mt-5">
          <div className="sec-heading centered">
            <div className="content-area">
              <h2 className="title">
                <span className="hollow-text">Sigma Quadrant –</span> 90 Days
              </h2>
            </div>
          </div>

          <div className="faq-accordion" id="accordion">
            <div className="row">
              <div className="col-12 col-lg-12">
                {faqItems.map((faq, index) => (
                  <div className="card mb-2" key={index}>
                    <div className="card-header" id={`heading-${index}`}>
                      <h5 className="mb-0 faq-title">
                        <button
                          className={`btn btn-link faq-btn ${
                            openIndex === index ? "" : "collapsed"
                          }`}
                          onClick={() => toggleFaq(index)}
                        >
                          {faq.title}
                        </button>
                      </h5>
                    </div>
                    {openIndex === index && (
                      <div className="card-body">
                        <ul
                          className="faq-answer"
                          style={{ listStyleType: "disc", paddingLeft: "20px" }}
                        >
                          {faq.content.map((item, i) => (
                            <li key={i}>{item}</li>
                          ))}
                        </ul>
                      </div>
                    )}
                  </div>
                ))}
              </div>

              {/* Subscribe Button */}
              <div className="col-md-12 text-center">
                <button
                  className="cta-btn btn-outline"
                  onClick={handlePlanSelect}
                >
                  Subscribe Now
                </button>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
